import * as $rdf from '@rdf-esm/data-model';
export function trailingSlash(response) {
  let id;

  if (response.requestedUri.endsWith('/')) {
    id = response.requestedUri.substr(0, response.requestedUri.length - 1);
  } else {
    id = response.requestedUri + '/';
  }

  return $rdf.namedNode(id);
}